import { render, staticRenderFns } from "./EditUsuario.vue?vue&type=template&id=7906ee5d&"
import script from "./EditUsuario.vue?vue&type=script&lang=js&"
export * from "./EditUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports